import { HttpService } from './HttpService';
import { Application } from '@/models/Application';

export class LoginService extends HttpService {

    public status = {
        currentUser: null
    }

    constructor(private app: Application, url: string) {
        super(url);
    }

    public currentUser() {
        const user = super.currentUser();
        this.status.currentUser = user;
        return user;
    }

    public login(username: string, password: string) {
        return new Promise((resolve, reject) => {
            this.post("/auth/login", {
                email: username,
                password: password
            }).then((result) => {
                const token = result.data.access_token;

                if (result.data.error) {
                    reject({
                        errorMessage: result.data.error
                    });
                }

                if (token) {
                    localStorage.setItem("access_token", token);
                    this.status.currentUser = this.currentUser();
                    resolve(this.currentUser());

                    this.app.onLogin();

                } else {
                    reject({
                        errorMessage: "Invalid username or password"
                    });
                }
            }).catch((error) => {
                reject({
                    errorMessage: "Error during login request"
                });
            });
        });
    }

    public async logout(): Promise<any> {
        localStorage.removeItem("access_token");
        this.status.currentUser = null;
        return true;
    }

    public async isValidLogin(): Promise<any> {
        let result = await this.get("/auth/isvalid");
        return result.data.isLogged
    }
}

export enum UserType {
    SuperAdministrator = 1,
    Administrator = 2,
    Waiter = 3,
    Customer = 4,
    Cook = 5,
    Bartender = 6,
    Driver = 7
}
